// removed by extract-text-webpack-plugin
module.exports = {"previewButton":"_18ksk","addToCart":"DIUDP"};